export enum MediaType {
  banner = 'banner',
  video = 'video',
  outstream = 'outstream'
}
